// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"7cf2346f","258":"664cc05e","352":"d26ed3d7","385":"71850fa0","452":"46219afd","594":"ea811910","771":"d6f56f3f"}[chunkId] + ".chunk.css";
};